/* WTH Legal pages — builds the "On this page" table of contents from the
   rendered h2/h3 headings (page.content is merchant-owned, so the TOC must be
   derived client-side), with scroll-spy highlighting. No dependencies.
   Stays a no-op (TOC hidden) when there are fewer than 2 headings.
   The TOC is a single details disclosure: open in the desktop sidebar, closed
   by default when the layout stacks (phones/tablets), so it never pushes the
   policy text down. */
(function () {
  'use strict';

  function slugify(text, fallback) {
    var s = (text || '')
      .toLowerCase()
      .trim()
      .replace(/['".,;:!?()/\\]/g, '')
      .replace(/[^a-z0-9À-ɏə\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    return s || fallback;
  }

  function init() {
    var body = document.getElementById('wth-legal-body');
    var toc = document.getElementById('wth-legal-toc');
    if (!body || !toc) return;

    var headings = body.querySelectorAll('h2, h3');
    if (headings.length < 2) return; // not worth a TOC

    var list = toc.querySelector('ul');
    if (!list) return;

    var entries = [];
    Array.prototype.forEach.call(headings, function (h, i) {
      if (!h.id) {
        var base = slugify(h.textContent, 'section-' + (i + 1));
        var id = base;
        var n = 1;
        while (document.getElementById(id)) { id = base + '-' + (++n); }
        h.id = id;
      }
      var li = document.createElement('li');
      li.className = 'wth-legal__toc-' + h.tagName.toLowerCase();
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent; // textContent: avoids HTML-entity double-encoding
      li.appendChild(a);
      list.appendChild(li);
      entries.push({ heading: h, link: a });
    });

    // Same disclosure at every width: open in the desktop sidebar, closed when the
    // sidebar stacks above the body (<= 990px, mirrors wth-legal.css).
    var details = toc.querySelector('details');
    var desktop = window.matchMedia ? window.matchMedia('(min-width: 991px)') : null;
    var syncOpen = function () {
      if (details && desktop) details.open = desktop.matches;
    };
    syncOpen();
    if (desktop) {
      if (desktop.addEventListener) desktop.addEventListener('change', syncOpen);
      else if (desktop.addListener) desktop.addListener(syncOpen);
    }

    toc.hidden = false;

    // Smooth in-page scroll + keep the URL hash in sync.
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    list.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      var id = decodeURIComponent((a.getAttribute('href') || '').slice(1));
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      // Stacked layout: fold the TOC BEFORE scrolling — it sits above the body, so
      // collapsing it afterwards would shift the target out of place.
      if (details && desktop && !desktop.matches) details.open = false;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) { history.replaceState(null, '', '#' + id); }
      else { window.location.hash = id; }
    });

    // Scroll-spy: highlight the heading currently in view.
    if ('IntersectionObserver' in window) {
      var setActive = function (link) {
        entries.forEach(function (en) { en.link.classList.remove('is-active'); });
        if (link) link.classList.add('is-active');
      };
      var visible = [];
      var spy = new IntersectionObserver(function (records) {
        records.forEach(function (r) {
          var id = r.target.id;
          if (r.isIntersecting) {
            if (visible.indexOf(id) === -1) visible.push(id);
          } else {
            var idx = visible.indexOf(id);
            if (idx !== -1) visible.splice(idx, 1);
          }
        });
        if (visible.length) {
          // first visible heading in document order
          var firstId = null;
          for (var i = 0; i < entries.length; i++) {
            if (visible.indexOf(entries[i].heading.id) !== -1) { firstId = entries[i].heading.id; break; }
          }
          if (firstId) {
            var link = list.querySelector('a[href="#' + (window.CSS && CSS.escape ? CSS.escape(firstId) : firstId) + '"]');
            setActive(link);
          }
        }
      }, { rootMargin: '-88px 0px -70% 0px', threshold: 0 });
      entries.forEach(function (en) { spy.observe(en.heading); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
